import { render, staticRenderFns } from "./PaymentsCheck.vue?vue&type=template&id=6f5971db&scoped=true&"
import script from "./PaymentsCheck.vue?vue&type=script&lang=js&"
export * from "./PaymentsCheck.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsCheck.vue?vue&type=style&index=0&id=6f5971db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5971db",
  null
  
)

export default component.exports